import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectItem } from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-product-type',
    templateUrl: './select-product-type.component.html',
    styleUrls: ['./select-product-type.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectProductTypeComponent
        }
    ],
    standalone: false
})
export class SelectProductTypeComponent implements OnInit, ControlValueAccessor {
  productType:SelectItem;
  productTypes:SelectItem[];

  @Input() value: string;
  @Output() change = new EventEmitter<SelectItem>();
  @Input() disabled: boolean = false;
  @Input() cache: false;

  onChange = (value) => {};
  onTouched = () => {};
  touched = false;
  constructor() { }

  ngOnInit() {
    this.productTypes = [{
      value: "car",
      label: "Voiture"
    },{
      value: "hotel",
      label: "Hotel"
    },{
      value: "flight",
      label: "Vol"
    }]
  }


  writeValue(codeProvider: any): void {
    this.value = codeProvider;
    this.updateValue();
  }
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if(changes.value){
      this.updateValue();
    }
  }

  private updateValue(){
    if(this.productTypes == null){
      return;
    }
    if(this.value){
      this.productType = this.productTypes.find(d => d.value == this.value);
      return;
    } 
    this.productTypeChange();
  }
  
  productTypeChange(){
    if(this.productType != null && !this.disabled){
      this.onChange((<SelectItem>this.productType).value);
      this.markAsTouched();
      this.change.emit(this.productType);
    }
  }

}
